
<template>

	<div class="pageBox" id="pageBox" v-show="this.showPaper">
		<!--page start-->
		<div class="lesson_study" >
			<!--我的作业列表-->
			<div class="lesson_taskList">
				<!--循环 开始-->
				<div class="taskContent radius5" v-for="paper in paperList">
					<h3>{{paper.paper_title}}</h3>
					<p class="item01">总分：100</p>
					<p class="item02">题数：{{paper.paper_total}}</p>
					<p class="item03">时限：30分钟</p>
					<div class="scoreEle">
						上次得分：<strong>{{paper.paper_score}}</strong>
					</div>
					<div class="btnGroup center clearfix">
						<a class="pointer radius3 btnItem fl btnItem02" v-on:click="doAnalysis(paper.paper_id)">查看解析</a>
					</div>
				</div>
				<!--循环 结束-->

				<div style="width: 100%;height: 1rem;line-height: 1rem;font-size: .16rem;text-align: center;"  v-show="page < totalPage" @click="getPaperList">
					点击加载更多...
				</div>
				<div style="width: 100%;height: 1rem;line-height: 1rem;font-size: .16rem;text-align: center;"  v-show="page >= totalPage">
					没有更多了
				</div>

			</div>
		</div>
		<!--page end-->
	</div>

</template>

<script>

    import http from "../../lib/http";

    export default {
        name: 'MyPaper',
        data() {
            return {
                page: 0, //分页
                showPaper: false, //控制页面显示隐藏
                pageSize:10, //
                totalPage:0, //总页数
				paperList:[], //试卷列表
            }
        },
        methods: {
			getPaperList:function () {
			    this.page++;
                const self = this;
                http({
                    method: "post",
                    url: "/org/exam/list",
                    data: "page="+self.page+"&page_size="+self.pageSize,
                }).then(function(res){
                    if(res.code == 0){
						self.totalPage = res.data.page.page_total;
                        self.paperList = [].concat(self.paperList,res.data.list);
                        self.showPaper = true;
                    }
                }).catch(function(err){

                });
            },
            doAnalysis:function (paperId) {
                this.$router.push('/paper-analysis?paper_id='+paperId);
            },
        },
        created(){
			this.getPaperList();
        },

    }
</script>

<style scoped>
	@import "//images.jinku.com/newjk/h5/css/global_mobile.css";
	@import "//images.jinku.com/newjk/h5/css/public.css";
	@import "//images.jinku.com/newjk/h5/css/lesson_study.css";

</style>



// WEBPACK FOOTER //
// src/components/personal/my-paper.vue